// extracted by mini-css-extract-plugin
export default {"maintenance":"maintenance___qUj4p","content":"content___l7pBs","top":"top___JWoXN","badge":"badge___W8mgW","bottom":"bottom___wILM5"};